"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChartTooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Components_1 = require("../../../Components");
var chartUtils_1 = require("../../chartUtils");
var ChartTooltipUtils_1 = require("../ChartTooltipUtils");
var ChartTooltipStyles_1 = require("../ChartTooltipStyles");
var theme_1 = require("../../../theme");
exports.LineChartTooltip = function (_a) {
    var data = _a.data, colorScale = _a.colorScale, positiveNegativeLine = _a.positiveNegativeLine;
    var sortedData = data
        .filter(function (d) { return d.value !== undefined; })
        .sort(function (a, b) { return b.value.y - a.value.y; });
    var getTooltipIconColor = function (d) {
        if (positiveNegativeLine && d.ID === positiveNegativeLine.ID) {
            return d.value.y >= 0
                ? theme_1.theme.colors.positiveGreen
                : theme_1.theme.colors.negativeRed;
        }
        return colorScale(d);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, sortedData.length > 0 && (react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null, sortedData.map(function (d) { return (react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, { key: d.ID },
        react_1.default.createElement(Components_1.Icon, { name: d.icon, style: { color: getTooltipIconColor(d), fontSize: '1.6rem' } }),
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, d.label),
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { style: {
                color: d.value.y < 0 ? ChartTooltipUtils_1.NEGATIVE_COLOR : ChartTooltipUtils_1.POSITIVE_COLOR,
            } }, chartUtils_1.formatLinearNumbers(d.value.y)))); })))));
};
exports.LineChartTooltip.displayName = 'FOS__LineChartTooltip';
